
import { Suspense, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import CentervilleHero from './components/CentervilleHero';
import CentervilleTrust from './components/CentervilleTrust';
import CentervilleServices from './components/CentervilleServices';
import CentervilleNeighborhoods from './components/CentervilleNeighborhoods';
import CentervilleTestimonial from './components/CentervilleTestimonial';
import CentervilleContact from './components/CentervilleContact';

export default function CentervillePage() {
  useEffect(() => {
    window.scrollTo(0, 0);

    document.title = 'Water Damage Restoration Centerville Utah | 24/7 Emergency Flood Cleanup Services';

    const metaTags = [
      { name: 'description', content: 'Expert water damage restoration in Centerville, Utah. 24/7 emergency flood cleanup, mold remediation, and fire damage repair near Deuel Creek & Parrish Lane. Fast response, certified professionals. Call (385) 340-6632 for immediate assistance.' },
      { name: 'keywords', content: 'water damage restoration Centerville, flood cleanup Centerville Utah, emergency water removal Centerville, mold remediation Centerville, fire damage repair Centerville' },
      { name: 'geo.position', content: '40.9183;-111.8721' },
      { name: 'geo.region', content: 'US-UT' },
      { name: 'geo.placename', content: 'Centerville, Utah' },
      { property: 'og:title', content: 'Water Damage Restoration Centerville Utah | Davis County Disaster Cleanup' },
      { property: 'og:description', content: '24/7 emergency water damage restoration in Centerville. Expert flood cleanup, mold removal, and disaster recovery services.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://daviscountydisastercleanup.com/centerville' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Water Damage Restoration Centerville Utah | Davis County Disaster Cleanup' },
      { name: 'twitter:description', content: '24/7 emergency water damage restoration in Centerville. Expert flood cleanup and disaster recovery.' }
    ];

    metaTags.forEach(({ name, property, content }) => {
      const attr = name ? 'name' : 'property';
      const value = name || property;
      let meta = document.querySelector(`meta[${attr}="${value}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, value as string);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content as string);
    });

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://daviscountydisastercleanup.com/centerville');

    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Do you provide 24/7 emergency water damage restoration in Centerville?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Davis County Disaster Cleanup provides 24/7 emergency water damage restoration services throughout Centerville, Utah. We respond immediately to water emergencies near Deuel Creek, Parrish Lane, Centerville Heights, and all Centerville neighborhoods."
          }
        },
        {
          "@type": "Question",
          "name": "How quickly can you respond to water damage in Centerville?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We typically arrive within 60 minutes for emergency water damage calls in Centerville. Our local team knows the area well, from Deuel Creek to Parrish Creek, ensuring rapid response times."
          }
        },
        {
          "@type": "Question",
          "name": "What areas of Centerville do you serve?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We serve all of Centerville including Deuel Creek area, Parrish Creek, Centerville Heights, East Centerville, Pages Lane, and Creekside. No location in Centerville is too far for our emergency response team."
          }
        }
      ]
    };

    let script = document.querySelector('script[data-schema="centerville-faq"]');
    if (!script) {
      script = document.createElement('script');
      script.setAttribute('type', 'application/ld+json');
      script.setAttribute('data-schema', 'centerville-faq');
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(faqSchema);

    return () => {
      const schemaScript = document.querySelector('script[data-schema="centerville-faq"]');
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, []);

  return (
    <Suspense fallback={<div className="min-h-screen bg-white"></div>}>
      <div className="min-h-screen bg-white">
        <Navbar />
        <CentervilleHero />
        <CentervilleTrust />
        <CentervilleServices />
        <CentervilleNeighborhoods />
        <CentervilleTestimonial />
        <CentervilleContact />
        <Footer />
      </div>
    </Suspense>
  );
}
